import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Modal, Pagination, Row, Space, Table } from "antd";

import Swal from "sweetalert2";

import { setLoading } from "../../redux/store/common/commonDuck";
import ApiService from "../../utils/ApiService";
import ProductNav from "../products/ProductNav";

const api = new ApiService();

const AddImportProductModal = ({
	importShow,
	setImportShow,
	setImgSrc,
	setProductInfo,
}) => {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const pageSize = 10;
	const [currentPageNumber, setCurrentPageNumber] = useState(1);

	const [categoryList, setCategoryList] = useState([]);
	const [subCategoryList, setSubCategoryList] = useState([]);
	const [allCount, setAllCount] = useState(0);
	const [productList, setProductList] = useState([]);

	const [category, setCategory] = useState({
		// category_id: "vitamin",
		// category_name: "비타민",
		category_id: "all",
		category_level: 2,
		category_name: "전체",
	});
	const [subCategory, setSubCategory] = useState({
		category_id: "all",
		category_name: "전체",
		category_parent: "vitamin",
	});

	const [sortType, setSortType] = useState({
		name: "이름순",
		orderType: "name",
		orderBy: "asc",
	});
	const [selectedRowKey, setSelectedRowKey] = useState([]);
	const [selectedRow, setSelectedRow] = useState([]);

	console.log(selectedRow, selectedRowKey);
	const rowSelection = {
		selectedRowKeys: selectedRowKey,
		onSelect: (record, selected) => {
			if (selectedRow?.length === 0) {
				if (selected) {
					setSelectedRow([record]);
					setSelectedRowKey([record.product_id]);
				} else {
					setSelectedRowKey([]);
					setSelectedRow([]);
				}
			} else {
				if (!selected) {
					if (record.product_id === selectedRowKey[0]) {
						setSelectedRowKey([]);
						setSelectedRow([]);
					}
				} else {
					setSelectedRow([record]);
					setSelectedRowKey([record.product_id]);
				}
			}
		},
	};

	useEffect(() => {
		getCategoryList();
		setSortType({
			name: "이름순",
			orderType: "name",
			orderBy: "asc",
		});
	}, []);

	useEffect(() => {
		if (category.category_id === "all") {
			getCategoryList();
		} else {
			handleSubCategory(subCategory);
		}
	}, [sortType]);

	/**
	 * 카테고리 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategoryList = async () => {
		setIsLoading(true);
		const res = await api.getProductCategoryAll();
		if (res.data.code === 200) {
			// 2레벨
			let list = [
				{
					category_id: "all",
					category_level: 2,
					category_name: "전체",
				},
			];
			let parent = {};
			res.data.result?.level2.map((item, idx) => {
				if (item.is_show && idx < 4) {
					list.push(item);
				}
				if (item.category_id === "vitamin") {
					parent = item;
				}
			});

			// 3레벨
			let param = {
				category_level: 3,
				category_parent: parent?.category_id,
				pageType: "register",
				userId: user?.id,
			};
			const rsp = await api.getProductCategoryList(param);
			if (rsp.data.code === 200) {
				setSubCategoryList([
					{
						category_id: "all",
						category_name: "전체",
						count: rsp.data.result.count,
						category_parent: parent?.category_id,
					},
					...rsp.data.result.productCategoryDTOList,
				]);
			}
			setCategoryList(list);
			setCurrentPageNumber(1);

			// 상품 리스트
			let param2 = {
				searchType: "all",
				searchText: "",
				user_id: user.id,
				pageSize: 10,
				offset: 0,
				search_age: 99, //filter.age,
				gender_id: 1, // filter.gender,
				orderType: sortType.orderType, // filter.sort_by[0],
				orderBy: sortType.orderBy, // filter.sort_by[1],
				pageType: "register",
			};
			const result = await api.getSearchListNew(param2);
			if (result.data.code === 200) {
				setAllCount(result.data.result?.totalCnt);
				setProductList(result.data.result?.nutrientsKpiList);
				setCategory({
					category_id: "all",
					category_name: "전체",
				});
			}
		}

		setIsLoading(false);
	};

	/**
	 * 카테고리 클릭시
	 * @param item
	 * @returns {Promise<void>}
	 */
	const handleCategory = async (item) => {
		setIsLoading(true);
		if (item.category_id === "all") {
			handleSearch("");
		} else {
			let param = {
				category_level: 3,
				category_parent: item?.category_id,
				pageType: "register",
				userId: user?.id,
			};
			const res = await api.getProductCategoryList(param);
			if (res.data.code === 200) {
				setSubCategoryList([
					{
						category_id: "all",
						category_name: "전체",
						count: res.data.result.count,
						category_parent: item?.category_id,
					},
					...res.data.result.productCategoryDTOList,
				]);
				setSubCategory({
					category_id: "all",
					category_name: "전체",
					count: res.data.result.count,
					category_parent: item?.category_id,
				});
				setCurrentPageNumber(1);
			}
			let param2 = {
				offset: 0,
				pageSize: 10,
				searchType: "category_2_all",
				categoryId: item.category_id,
				userId: user.id,
				orderType: sortType.orderType,
				orderBy: sortType.orderBy,
				pageType: "register",
			};
			const rsp = await api.getProductItemCategory(param2);
			if (rsp.data.code === 200) {
				setProductList(rsp.data.result.productDTOList);
				setAllCount(rsp.data.result.totalCnt);
			}
		}
		setIsLoading(false);
	};

	/**
	 * 서브 카테고리 클릭 시
	 * @param item
	 * @returns {Promise<void>}
	 */
	const handleSubCategory = async (item) => {
		setIsLoading(true);
		let param = {
			offset: 0,
			pageSize: 10,
			searchType: item?.category_id === "all" ? "category_2_all" : "category",
			categoryId:
				item?.category_id === "all" ? item.category_parent : item?.category_id,
			userId: user.id,
			orderType: sortType.orderType,
			orderBy: sortType.orderBy,
			pageType: "register",
		};
		const res = await api.getProductItemCategory(param);
		if (res.data.code === 200) {
			setProductList(res.data.result.productDTOList);
			setAllCount(res.data.result.totalCnt);
			setCurrentPageNumber(1);
		}
		setIsLoading(false);
	};

	/**
	 * 브랜드, 상품 검색
	 * @param searchValue
	 * @returns {Promise<void>}
	 */
	const handleSearch = async (searchValue) => {
		setIsLoading(true);
		let param = {
			searchType: "all",
			searchText: searchValue,
			user_id: user?.id,
			pageSize: 10,
			offset: 0,
			search_age: 99, //filter.age,
			gender_id: 1, // filter.gender,
			orderType: sortType.orderType, // filter.sort_by[0],
			orderBy: sortType.orderBy, // filter.sort_by[1],
			pageType: "register",
		};
		const res = await api.getSearchListNew(param);
		if (res.data.code === 200) {
			setAllCount(res.data.result?.totalCnt);
			setProductList(res.data.result?.nutrientsKpiList);
			setCategory({
				category_id: "all",
				category_name: "전체",
			});
		}
		setIsLoading(false);
	};

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber, type) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
		if (category.category_id !== "all") {
			let param = {
				offset: currOffset,
				pageSize: 10,
				searchType:
					subCategory?.category_id === "all" ? "category_2_all" : "category",
				categoryId:
					subCategory?.category_id === "all"
						? subCategory.category_parent
						: subCategory?.category_id,
				userId: user.id,
				orderType: sortType.orderType,
				orderBy: sortType.orderBy,
				pageType: "register",
			};
			const res = await api.getProductItemCategory(param);
			if (res.data.code === 200) {
				setProductList(res.data.result.productDTOList);
				setAllCount(res.data.result.totalCnt);
			}
		} else {
			let param = {
				searchType: "all",
				searchText: "",
				user_id: user?.id,
				pageSize: 10,
				offset: currOffset,
				search_age: 99, //filter.age,
				gender_id: 1, // filter.gender,
				orderType: sortType.orderType, // filter.sort_by[0],
				orderBy: sortType.orderBy, // filter.sort_by[1],
				pageType: "register",
			};
			const res = await api.getSearchListNew(param);
			if (res.data.code === 200) {
				setAllCount(res.data.result?.totalCnt);
				setProductList(res.data.result?.nutrientsKpiList);
				setCategory({
					category_id: "all",
					category_name: "전체",
				});
			}
		}
		// const search = document.getElementById("main-title");
		if (type !== "query") {
			const modalBody = document.getElementsByClassName("ant-modal-body");
			if (modalBody?.[1]) {
				modalBody[1].scrollTo({
					// top: search.offsetTop - (5 * 16),
					top: 0,
					behavior: "smooth",
				});
			}
		}
	};

	const columns = [
		{
			title: "제품정보",
			dataIndex: "",
			// key: 'order_id',
			width: "43%",
			align: "center",
			render: (_, record, idx) => {
				return (
					<div
						className={`import-table-product-cell`}
						key={`import-table-product-cell-${idx}`}
					>
						<div className={`import-product-image`}>
							<img
								src={`${process.env.REACT_APP_S3_HOST}/image/recommend/${record?.target_id}.jpg`}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null; // prevents looping
									// currentTarget.style.display = "none";
									currentTarget.src = `/assets/images/no-product.png`;
								}}
								alt={`${record?.product_brand_name} ${record?.product_name}`}
							/>
						</div>
						<div className={`import-product-info`}>
							<Space className={`tag-list`}>
								{record.is_best && (
									<Button className={`tag-black`}>BEST</Button>
								)}
								{record.is_new && <Button className={`tag`}>NEW</Button>}
								{record.exposure_tag_1 && (
									<Button className={`tag`}>{record.exposure_tag_1}</Button>
								)}
								{record.exposure_tag_2 && (
									<Button className={`tag`}>{record.exposure_tag_2}</Button>
								)}
								{record.exposure_tag_3 && (
									<Button className={`tag`}>{record.exposure_tag_3}</Button>
								)}
							</Space>

							<div className={`product-name-wrap`}>
								<p className={`product-brand-name`}>
									{record.product_brand_name
										? record.product_brand_name
										: record.brand_name}
								</p>
								<p className={`product-name`}>
									{record.product_name ? record.product_name : record.name}
								</p>
								<p className={`price`}>
									{record.price_2
										? record.price_2?.toLocaleString()
										: record.price_1?.toLocaleString()}
									원
								</p>
								<Row style={{ gap: "2px" }} align={"middle"}>
									<img
										src={`/assets/images/products/review.png`}
										alt={`화살표`}
										style={{
											height: "0.8em",
											width: "auto",
										}}
									/>
									{!record?.review_score ? (
										<p className={`review`}>
											{record?.total_review_score
												? record?.total_review_score.toFixed(1)
												: 0}{" "}
											(
											{record?.total_review_cnt > 999
												? "999+"
												: record?.total_review_cnt}
											)
										</p>
									) : (
										<p className={`review`}>
											{record?.review_score
												? record?.review_score.toFixed(1)
												: 0}{" "}
											(
											{record?.review_count > 999
												? "999+"
												: record?.review_count}
											)
										</p>
									)}
								</Row>
							</div>
						</div>
					</div>
				);
			},
		},
		{
			title: "상품 특징",
			dataIndex: "",
			width: "43%",
			align: "center",
			render: (_, record, idx) => {
				let arr = Array.from({ length: 6 }).map(
					(item, idx) => record?.[`information_${idx + 1}`]
				);
				if (arr?.length && record?.usp) {
					return (
						<div
							className={`import-table-usp-cell`}
							key={`import-table-usp-cell-${idx}`}
						>
							<p className={`usp`}>{record?.usp}</p>
							{arr?.map((item, idx) => {
								if (record?.[`information_${idx + 1}`]) {
									return (
										<div
											className={`import-information-div`}
											key={`import-information-${idx}`}
										>
											<p className={`number`}>0{idx + 1}</p>
											<p>{record?.[`information_${idx + 1}`]}</p>
										</div>
									);
								} else {
									return <></>;
								}
							})}
						</div>
					);
				} else {
					return "-";
				}
			},
		},
		{
			title: "커미션",
			dataIndex: "commission_rate",
			key: "commission_rate",
			width: "10%",
			align: "center",
			render: (value) => <span>{value}%</span>,
		},
	];

	const [queryValid, setQueryValid] = useState(false);
	// const [queryCreate, setQueryCreate] = useState(false);
	const queryCreate = useRef(false);

	const submitSelect = () => {
		// console.log(selectedRow[0]?.product_link);
		if (selectedRow?.length) {
			if (selectedRow[0]?.product_link) {
				let param = {
					category_id: selectedRow.ingredient_id,
					category_name: selectedRow.ingredient_name,
					brand_name: selectedRow[0]?.brand_name
						? selectedRow[0].brand_name
						: selectedRow[0].product_brand_name,
					product_name: selectedRow[0]?.name
						? selectedRow[0].name
						: selectedRow[0].product_name,
					sub_title: selectedRow[0]?.usp ? selectedRow[0].usp : "",
					descriptionList: [
						selectedRow[0]?.information_1,
						selectedRow[0]?.information_2,
						selectedRow[0]?.information_3,
						selectedRow[0]?.information_4,
						selectedRow[0]?.information_5,
						selectedRow[0]?.information_6,
					],
					purchaseList: [
						{
							type: "4",
							url: `https://www.dangyoung.com/products/${
								selectedRow[0]?.target_id
							}${
								selectedRow[0]?.product_link
									? `?query=${selectedRow[0]?.product_link}`
									: ""
							}`,
							discount_code: "",
						},
						{
							type: "",
							url: "",
							discount_code: "",
						},
					], // type, url, discount_code
					search_tag: "",
					img_type: "jpg",
					product_master_id: selectedRow[0]?.product_id,
				};
				setImgSrc(
					`${process.env.REACT_APP_S3_HOST}/image/recommend/${selectedRow[0]?.target_id}.jpg`
				);
				if (queryCreate.current) {
					Swal.fire({
						customClass: "alert-custom",
						text: "구매 링크가 새로 생성된 상품입니다. 등록하기 전에 다시 한 번 확인해주세요!\nex)www.dangyoung.com/products/4855?query=e0zuCOzN",
						confirmButtonText: "확인",
					});
					queryCreate.current = false;
				}
				setProductInfo(param);
				setImportShow(false);
				setQueryValid(false);
			} else {
				checkNotDuplication(selectedRow[0]);
			}
		}
	};

	/**
	 * 쿼리 중복 여부 체크
	 * @returns {Promise<{result, query: string}>}
	 * true : 중복 아님, false: 중복
	 */
	const checkNotDuplication = async (item) => {
		let text = "";
		const possible =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let isValid = false;
		while (!isValid) {
			for (let i = 0; i < 8; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}
			let param = {
				user_id: user.id,
				product_id: item.product_id,
				query: text,
			};
			const res = await api.checkDuplicateProductLink(param);
			if (res.data.code === 200) {
				if (!isValid) {
					createRandomQuery({
						result: res.data.result,
						query: text,
						item: item,
					});
				}
				isValid = true;
			}
		}
	};

	/**
	 * 쿼리 생성
	 * @returns {Promise<void>}
	 */
	const createRandomQuery = async (returnQuery) => {
		// true: 중복아님, false: 중복
		// if (!queryLoading) {
		// 	setQueryLoading(true);
		// }
		const { result, query, item } = returnQuery;
		const dataQuery = !!item?.product_link;
		if (!dataQuery && result) {
			let param = {
				product_id: item?.product_id,
				user_id: user.id,
				query: query,
			};
			const res = await api.issueProductLink(param);
			if (res.data.code === 200) {
				// setQueryUrl(res.data.result.query);
				// setLinkShow(true);
				// handleChangePagination(currentPageNumber, "query");
				let answer = { ...item };
				answer["product_link"] = res.data.result.query;
				setSelectedRow([answer]);
				setQueryValid(true);
				queryCreate.current = true;
			}
		}
		// setQueryLoading(false);
	};

	useEffect(() => {
		if (queryValid && selectedRow[0]?.product_link) {
			submitSelect();
		}
	}, [queryValid, selectedRow]);

	return (
		<Modal
			title={`상품 불러오기`}
			wrapClassName="edit-channel-modal import-modal"
			open={importShow}
			centered={true}
			onCancel={() => {
				setImportShow(!importShow);
				setSelectedRow([]);
				setSelectedRowKey([]);
			}}
			width="60%"
			footer={
				<Row className={`import-footer-row`}>
					<Row className={`select-row`}>
						<p className={`select-row-title`}>선택한 항목</p>
						<p>
							{selectedRow?.[0]?.brand_name
								? selectedRow?.[0]?.brand_name
								: selectedRow?.[0]?.product_brand_name}{" "}
							{selectedRow?.[0]?.name
								? selectedRow?.[0]?.name
								: selectedRow?.[0]?.product_name}
						</p>
					</Row>
					<Button
						className={`ant-btn-primary`}
						onClick={submitSelect}
						loading={isLoading}
						disabled={selectedRow?.length === 0}
					>
						<span className={`finish`}>선택 완료</span>
					</Button>
				</Row>
			}
		>
			{/* 상품 검색 form */}
			<div className={`add-modal-body-each-border product-import`}>
				<ProductNav
					categoryList={categoryList}
					subCategoryList={subCategoryList}
					handleCategory={handleCategory}
					category={category}
					setCategory={setCategory}
					handleSubCategory={handleSubCategory}
					subCategory={subCategory}
					setSubCategory={setSubCategory}
					handleSearch={handleSearch}
				/>
			</div>

			{/* 상품 내역 불러오기 */}
			<div className={`product-import-body`}>
				<p className={`product-import-title`}>전체 {allCount}개</p>

				<Table
					rowSelection={{
						type: "checkbox",
						// type: "radio",
						...rowSelection,
					}}
					onRow={(record) => {
						return {
							onClick: () => {
								setSelectedRow([record]);
								setSelectedRowKey([record.product_id]);
							},
						};
					}}
					className={"import-product-table"}
					columns={columns}
					dataSource={productList}
					bordered
					size={"small"}
					rowKey={`product_id`}
					pagination={false}
					loading={isLoading}
				/>

				{!isLoading && (
					<Pagination
						className="report-pagination-wrap"
						showSizeChanger={false}
						current={currentPageNumber}
						pageSize={pageSize}
						total={allCount}
						onChange={handleChangePagination}
					/>
				)}
			</div>
		</Modal>
	);
};
export default AddImportProductModal;
